import React from 'react';
import MolduraJuridica from '../components/juridico/MolduraJuridica';
import { PRIVACIDADE } from '../juridico/privacidade';

/* Política de Privacidade no desenho novo; a antiga (PrivacyPolicy.js) volta trocando o import em App.js. */
const NewPrivacyPolicy = ({ user }) => (
  <MolduraJuridica user={user} doc={PRIVACIDADE} irmao={{ caminho: '/terms-of-service', nome: 'site.termos' }} />
);

export default NewPrivacyPolicy;
